import { render } from "./CustomerHeader.vue?vue&type=template&id=1e45c35a&scoped=true"
import script from "./CustomerHeader.vue?vue&type=script&lang=js"
export * from "./CustomerHeader.vue?vue&type=script&lang=js"

import "./CustomerHeader.vue?vue&type=style&index=0&id=1e45c35a&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e45c35a"]])

export default __exports__